export function OutlineGridIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00161 3H4.9968C3.894 3 3 3.894 3 4.9968V8.00161C3 9.10441 3.894 9.99841 4.9968 9.99841H8.00161C9.10441 9.99841 9.99841 9.10441 9.99841 8.00161V4.9968C9.99841 3.894 9.10441 3 8.00161 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0031 3H15.9983C14.8955 3 14.0015 3.894 14.0015 4.9968V8.00161C14.0015 9.10441 14.8955 9.99841 15.9983 9.99841H19.0031C20.1059 9.99841 20.9999 9.10441 20.9999 8.00161V4.9968C20.9999 3.894 20.1059 3 19.0031 3Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00161 14.002H4.9968C3.894 14.002 3 14.896 3 15.9988V19.0036C3 20.1064 3.894 21.0004 4.9968 21.0004H8.00161C9.10441 21.0004 9.99841 20.1064 9.99841 19.0036V15.9988C9.99841 14.896 9.10441 14.002 8.00161 14.002Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0031 14.002H15.9983C14.8955 14.002 14.0015 14.896 14.0015 15.9988V19.0036C14.0015 20.1064 14.8955 21.0004 15.9983 21.0004H19.0031C20.1059 21.0004 20.9999 20.1064 20.9999 19.0036V15.9988C20.9999 14.896 20.1059 14.002 19.0031 14.002Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
